import { TasksTableFilters } from "../types";

const tasksTableFilters: TasksTableFilters = {
  search: "",
  status: ["all"],
  priority: ["all"],
};

export { tasksTableFilters };
